import Database from "@/controller/database";

export default async function existAnotherEnterpriseInspectionNotTransmited(tokenToCompare) {
    const database = new Database();

    let inspectionsOnDatabase;
    await database
        .createOrOpenDatabase({ listAllInspectionData: true })
        .then((response) => {
            inspectionsOnDatabase = response;
        })
        .catch(() => (this.inspections = []));

    let existAnotherEnterpriseInspectionNotTransmitedVar = false;
    for (let i = 0; i < inspectionsOnDatabase.length; i++) {
        const inspection = inspectionsOnDatabase[i].inspection;
        if (
            inspection.status == "Pendente" &&
            inspection.enterprise.enterprise != tokenToCompare
        ) {
            existAnotherEnterpriseInspectionNotTransmitedVar = true;
        }
    }
    return existAnotherEnterpriseInspectionNotTransmitedVar;
}
